/** Allowlist mirrors the CF Worker at deploy/cf-worker/worker.js — the worker
 *  refuses any other host. Whitelisted upstreams get proxied via the edge
 *  cache; everything else flows through directly. */
const CDN_HOSTS = ["i.scdn.co", "mosaic.scdn.co", "wrapped-images.spotifycdn.com",
                   "e-cdns-images.dzcdn.net", "cdns-images.dzcdn.net",
                   "cdn-images.dzcdn.net", "e-cdn-images.dzcdn.net"];

function shouldEdgeCache(url: string): boolean {
  return CDN_HOSTS.some((h) => url.startsWith(`https://${h}/`));
}

// Deezer cover URLs encode their resolution right in the path:
//   .../images/cover/<hash>/500x500-000000-80-0-0.jpg
// The WxH segment is genuinely swappable server-side — this lets a 40px
// track-row thumbnail actually request a 40px image instead of downloading
// and decoding the same 500x500 (or 1000x1000) master everywhere. Spotify's
// CDN URLs have no such segment (the hash itself is the resolution — we'd
// need a different hash entirely, which we don't have past ingestion time),
// so this only applies to dzcdn hosts.
const DZ_SIZE_RE = /(\/images\/cover\/[^/]+\/)\d+x\d+(-[^/]+)$/;

function resizeDeezerUrl(url: string, size: number): string {
  const px = Math.max(1, Math.round(size));
  return url.replace(DZ_SIZE_RE, `$1${px}x${px}$2`);
}

export function coverUrl(coverIdOrUrl: string | null | undefined, size = 300): string {
  if (!coverIdOrUrl) return "";
  if (coverIdOrUrl.startsWith("http")) {
    const resized = coverIdOrUrl.includes(".dzcdn.net/")
      ? resizeDeezerUrl(coverIdOrUrl, size)
      : coverIdOrUrl;
    // Route allowlisted CDNs through the CF Worker at slowson.com/img/* so
    // every user hits the same edge-cached copy instead of the raw CDN.
    return shouldEdgeCache(resized) ? `/img/${resized}` : resized;
  }
  return `/api/media/cover/${coverIdOrUrl}?size=${size}`;
}
export function avatarUrl(avatarId: string | null | undefined, size = 96): string {
  if (!avatarId) return "";
  if (avatarId.startsWith("http")) {
    const resized = avatarId.includes(".dzcdn.net/") ? resizeDeezerUrl(avatarId, size) : avatarId;
    return shouldEdgeCache(resized) ? `/img/${resized}` : resized;
  }
  return `/api/media/avatar/${avatarId}?size=${size}`;
}
